import { Button, Typography, Form, Modal, Radio, Input, message, Upload, Checkbox } from 'antd'
import { IconFont, SignTitle, SvgIcon } from '@/components'
import { useState } from 'react'
import { UploadOutlined } from '@ant-design/icons'
import styled from 'styled-components'
import { useSelections } from 'ahooks'
import { useAddTemplate } from './utils'
import emptyImg from '@/assets/imges/Empty/Empty.png'
import { checkName } from '@/api/dp-template'
import { Message } from '@/components/message'
import { MdEditor } from '@/components/md-editor'
import MarkdownEditor from '@/components/markdown-editor'
import { t } from '@/i18n'

export const AddModal = props => {
  const { visible, setVisible } = props
  const { TextArea } = Input
  const [form] = Form.useForm()
  let userData
  try {
    userData = JSON.parse(localStorage.getItem('token') as string)
  } catch (error) {}
  const [type, setType] = useState(1)
  const [checked, setChecked] = useState(false)
  const [fileData, setFileData] = useState('')
  const [uploadLoading, setUploadLoading] = useState(false)
  const [fileFailed, setFileFailed] = useState(false)
  const [variables, setVariables] = useState([])
  const [fileName, setFileName] = useState('')
  const [filePath, setFilePath] = useState('')
  const [fileExt, setFileExt] = useState('')
  const [description, setDescription] = useState(null)
  const [fileDescription, setFileDescription] = useState('')
  const { selected, toggle, unSelectAll } = useSelections(variables)
  const [addTemplate] = useAddTemplate()
  const variablesWithInterpretation = [
    { name: 'name_en', value: t('随机英文名字') },
    { name: 'name_cn', value: t('随机中文名字') },
    { name: 'idcard', value: t('随机身份证号') },
    { name: 'bankno', value: t('随机银行卡号') },
    { name: 'phoneno', value: t('随机手机号') },
    { name: 'gender', value: t('随机性别') },
    { name: 'email', value: t('随机邮箱') },
    { name: 'email_account', value: t('生成与当前用户同域的随机邮箱') },
    { name: 'ip_ext', value: t('随机外网ip') },
    { name: 'ip_inter', value: t('随机内网ip') },
    { name: 'HKCardNo', value: t('港澳居民来往内地通行证') },
    { name: 'TWCardNo', value: t('台湾身份证') },
    { name: 'OfficerNo', value: t('军官证') },
    { name: 'AccountNo', value: t('户口本号') },
    { name: 'PassportNo', value: t('护照号码') },
    { name: 'DriverLicenseNo', value: t('驾驶证') },
  ]
  const checkedName = (value: string) =>
    new Promise((resolve, reject) => {
      checkName({ name: value })
        .then(res => {
          if (res.code === 200) {
            resolve(true)
          } else resolve(false)
        })
        .catch(error => {
          resolve(false)
        })
    })

  const submitHandler = values => {
    const { name } = values
    // console.log(filePath, values, name, description)
    const item = selected.map(e => `{{${e}}}`)
    let data
    switch (type) {
      case 1:
        data = {
          file_type: type,
          name: name,
          describe: description,
          file_name: fileName,
          file_path: filePath,
          file_ext: fileExt,
          content: fileData,
          variable_list: item,
        }
        break
      case 2:
        data = {
          file_type: type,
          name: name,
          describe: description,
          file_name: fileName,
          file_path: filePath,
          file_ext: fileExt,
          content: fileData,
          variable_list: item,
        }
        break
      case 3:
        data = {
          file_type: type,
          name: name,
          describe: description,
          content: fileData,
          variable_list: item,
        }
        break
      case 4:
        data = {
          file_type: type,
          name: name,
          describe: description,
          file_name: fileName,
          file_path: filePath,
          file_ext: fileExt,
        }
    }
    addTemplate({ ...data })
      .then(res => {
        setVisible(2)
        setDescription(null)
      })
      .catch(_ => {})
  }
  const onSubmit = () => {
    // 确定
    if ([1, 2, 3].includes(type) && fileData.length > 0) {
      form.submit()
    } else if (filePath.length > 0) {
      form.submit()
    } else {
      Message.error(t('数据内容不能为空'))
      return
    }
  }
  const onCheckVariable = () => {
    // 检测变量
    unSelectAll()
    let r = []
    let inBrace = false
    let variable = ''
    for (let i = 0; i < fileData.length; i++) {
      let char = fileData[i]
      let next = ''
      if (i < fileData.length) {
        next = fileData[i + 1]
      }
      if (char == '{' && next == '{') {
        i += 1
        inBrace = true
        continue
      }
      if (inBrace && char !== '}') {
        variable += char
        continue
      }
      if (char == '}' && next === '}') {
        if (inBrace && !r.includes(variable)) {
          r.push(variable)
        }
        i += 1
        inBrace = false
        variable = ''
      }
    }
    const list = variablesWithInterpretation.map(item => item.name)
    let result = r.filter(item => list.includes(item))
    setVariables(result)
    setChecked(false)
  }
  return (
    <Modal
      width="1000px"
      title={
        <SignTitle show style={{ width: '1000px' }}>
          {/*{templateDetail?.title || ''}*/}
          {t('添加自定义模板')}
        </SignTitle>
      }
      // bodyStyle={{ width: '700px' }}
      centered
      footer={[
        <div>
          <Button onClick={() => setVisible(1)}>{t('取消')}</Button>
          <Button disabled={checked} type="primary" onClick={() => onSubmit()}>
            {t('确定')}
          </Button>
        </div>,
      ]}
      visible
      onCancel={() => setVisible(1)}
      bodyStyle={{ height: '600px' }}
    >
      <Form
        form={form}
        onFinish={val => submitHandler(val)}
        layout={'vertical'}
        initialValues={{ type: 1 }}
      >
        <Form.Item
          label={t('模板名称')}
          name="name"
          rules={[
            { required: true, message: t('请输入模板名称') },
            {
              validateTrigger: 'onSubmit',
              validator: (_, value, callback) => {
                // console.log(value)
                if (value?.length > 0) {
                  checkedName(value).then(res => {
                    if (res) {
                      callback()
                      // return Promise.resolve()
                    } else {
                      callback(t('已存在'))
                      // return Promise.reject('此模板中已存在')
                    }
                  })
                } else {
                  callback()
                }
              },
            },
          ]}
        >
          <Input maxLength={60} style={{ width: '420px' }} placeholder={t('请输入')} />
        </Form.Item>
        <Form.Item label={t('添加方式')} name="type">
          <Radio.Group
            onChange={e => {
              setType(e.target.value)
              // form.setFieldValue('type', e.target.value)
              setFileName('')
              setFileData('')
              setFilePath('')
              setFileExt('')
              setVariables([])
              unSelectAll()
              setChecked(false)
              setFileFailed(false)
            }}
            value={type}
          >
            <Radio value={1}> {t('有格式（上传）')} </Radio>
            <Radio value={2}> {t('无格式（上传）')} </Radio>
            <Radio value={3}> {t('无格式（输入）')} </Radio>
            <Radio value={4}> {t('有格式且不可解析（上传）')} </Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item label={t('数据内容')} name="content">
          {[1, 2, 3].includes(type) && (
            <DataContent>
              <div>
                {fileData?.length > 0 && type !== 3 ? (
                  <div
                    style={{
                      height: '32px',
                      lineHeight: '32px',
                      display: 'flex',
                      // justifyContent: 'space-between',
                      alignItems: 'center',
                    }}
                  >
                    <IconFont type="icon-047-file" />
                    <Typography.Text className="file-name" ellipsis={{ tooltip: true }}>
                      {fileName}
                    </Typography.Text>
                    <IconFont
                      onClick={() => {
                        setFileData('')
                        setFileName('')
                        setFilePath('')
                        setFileExt('')
                        setVariables([])
                        setChecked(false)
                      }}
                      type="icon-shanchu-m"
                    />
                  </div>
                ) : type !== 3 ? (
                  <Upload
                    showUploadList={false}
                    disabled={uploadLoading}
                    headers={{
                      'user-id': userData.id,
                      token: userData.token,
                    }}
                    action={`${
                      process.env.NODE_ENV === 'dev' ? '/api' : ''
                    }/portal/verify/dataProtection/parseFile`}
                    beforeUpload={file => {
                      // let reg = /\.doc|\.docx|\.xls|\.xlsx$/

                      // let msg = '仅支持上传doc / docx / xls / xlsx 文件'
                      let reg = /\.docx|\.xls|\.xlsx$/
                      let msg = t('仅支持上传 docx / xls / xlsx 文件')
                      if (type == 2) {
                        reg = /\.txt$/
                        msg = t('仅支持上传txt文件')
                      }
                      if (reg.test(file.name)) {
                        return true
                      }
                      Message.error(msg)
                      setFileFailed(true)
                      return false
                    }}
                    onChange={({ file }) => {
                      setFileName('')
                      setFileData('')
                      setFilePath('')
                      setFileExt('')
                      if (file.status === 'uploading') {
                        setUploadLoading(true)
                        return
                      }
                      if (
                        file.status === 'done' ||
                        file.status === 'error' ||
                        file.status === 'success'
                      ) {
                        setUploadLoading(false)
                      }
                      if (file.status === 'done') {
                        const { code, msg } = file.response
                        if (code === 200) {
                          // setSteps(2)
                          setFileFailed(false)
                          setFileName(file.name)
                          setFileData(file.response?.data?.content || '')
                          setFilePath(file.response?.data?.file_path)
                          setChecked(true)
                          setFileExt(file?.response?.data?.file_ext)
                          // getEmailList$.emit()
                        } else {
                          setFileFailed(true)
                          Message.error(msg || t('上传失败'))
                        }
                        return
                      }
                      if (file.status === 'error') {
                        setFileFailed(true)
                        Message.error(t('上传失败'))
                      }
                    }}
                    name={'file'}
                    maxCount={1}
                  >
                    {fileData?.length > 0 ? (
                      <div />
                    ) : (
                      <Button type="primary" icon={<UploadOutlined />}>
                        {t('上传文件')}
                      </Button>
                    )}
                  </Upload>
                ) : (
                  <div style={{ height: 32, display: 'flex', alignItems: 'flex-end' }}>
                    {t('内容')}
                  </div>
                )}
                {fileData?.length > 0 && type === 1 ? (
                  <div className="content readonly-content">{fileData}</div>
                ) : fileData.length > 0 || type === 3 ? (
                  <TextArea
                    // autoSize={{ minRows: 11, maxRows: 11 }}
                    className="content"
                    value={fileData}
                    onChange={e => {
                      setFileData(e.target.value)
                      setChecked(true)
                    }}
                  />
                ) : (
                  <EmptyFile failed={fileFailed} className="empty-file content">
                    {type === 1 && (
                      <div style={{ marginTop: 20 }}>
                        <SvgIcon
                          name={'上传'}
                          style={{ height: 86, transform: 'translateX(-16px)' }}
                        />
                        {/* <div className="upload-text">支持上传doc / docx / xls / xlsx文件</div> */}
                        <div className="upload-text">{t('支持上传 docx / xls / xlsx文件')}</div>
                      </div>
                    )}
                    {type === 2 && (
                      <div style={{ marginTop: 20 }}>
                        <SvgIcon
                          name={'上传'}
                          style={{ height: 86, transform: 'translateX(-16px)' }}
                        />
                        <div className="upload-text">{t('支持上传txt文件')}</div>
                      </div>
                    )}
                  </EmptyFile>
                )}
              </div>
              <div>
                <div style={{ display: 'flex', alignItems: 'flex-end' }}>
                  <Button
                    style={{ marginRight: 6 }}
                    disabled={!checked}
                    type="primary"
                    onClick={() => onCheckVariable()}
                  >
                    {t('检测变量')}
                  </Button>
                  <span>{t('选择需要动态生成数据的变量')}</span>
                </div>
                <div className="variables content">
                  {variables.length > 0 ? (
                    <Checkbox.Group>
                      {variables.map((item, index) => (
                        <div key={index} style={{ marginBottom: '15px' }}>
                          <Checkbox onChange={() => toggle(item)} value={item}>
                            {item}
                          </Checkbox>
                        </div>
                      ))}
                    </Checkbox.Group>
                  ) : (
                    <div style={{ lineHeight: '150px', textAlign: 'center' }}>{t('无')}</div>
                  )}
                  {/*{variables.map((item, index) => (*/}
                  {/*  <div></div>*/}
                  {/*))}*/}
                </div>
              </div>
              <div>
                <div style={{ height: '32px', display: 'flex', alignItems: 'flex-end' }}>
                  {t('可使用的变量及释义')}
                </div>
                <div className="notes content">
                  {variablesWithInterpretation.map((item, index) => (
                    <div className="note" key={index} style={{ display: 'flex' }}>
                      <div className="name">{`{{${item.name}}}`}</div>
                      <div className="value">{item.value}</div>
                    </div>
                  ))}
                </div>
              </div>
            </DataContent>
          )}
          {type === 4 && (
            <Upload
              showUploadList={false}
              disabled={uploadLoading}
              headers={{
                'user-id': userData.id,
                token: userData.token,
              }}
              action={`${
                process.env.NODE_ENV === 'dev' ? '/api' : ''
              }/portal/verify/dataProtection/parseFile`}
              // beforeUpload={file => {
              //   let reg = /\.doc|\.docx$/
              //   let msg = '仅支持上传doc / docx文件'
              //   if (type == 2) {
              //     reg = /\.txt$/
              //     msg = '仅支持上传txt文件'
              //   }
              //   if (reg.test(file.name)) {
              //     return true
              //   }
              //   Message.error(msg)
              //   return false
              // }}
              onChange={({ file }) => {
                setFileName('')
                setFilePath('')
                setFileExt('')
                if (file.status === 'uploading') {
                  setUploadLoading(true)
                  return
                }
                if (
                  file.status === 'done' ||
                  file.status === 'error' ||
                  file.status === 'success'
                ) {
                  setUploadLoading(false)
                }
                if (file.status === 'done') {
                  const { code, msg } = file.response
                  // console.log(file)
                  if (code === 200) {
                    // setSteps(2)
                    setFileFailed(false)
                    setFilePath(file.response?.data?.file_path)
                    setFileName(file.name)
                    setFileExt(file.response?.data?.ext)
                    // getEmailList$.emit()
                  } else {
                    setFileFailed(true)
                    Message.error(msg || t('上传失败'))
                  }
                  return
                }
                if (file.status === 'error') {
                  setFileFailed(true)
                  Message.error(t('上传失败'))
                }
              }}
              // data={{
              //   // template_id: groupList?.ID,
              // }}
              name={'file'}
              maxCount={1}
            >
              {fileName.length > 0 ? (
                <FileName
                  style={{
                    height: '32px',
                    lineHeight: '32px',
                    display: 'flex',
                    // justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <IconFont type="icon-047-file" />
                  <Typography.Text className="file-name" ellipsis={{ tooltip: true }}>
                    {fileName}
                  </Typography.Text>
                  <IconFont
                    onClick={e => {
                      e.stopPropagation()
                      setFileData('')
                      setFileName('')
                      setFilePath('')
                      setFileExt('')
                    }}
                    type="icon-shanchu-m"
                  />
                </FileName>
              ) : (
                <Button type="primary" icon={<UploadOutlined />}>
                  {t('上传文件')}
                </Button>
              )}
            </Upload>
          )}
        </Form.Item>
        <Form.Item label={t('描述')} name="description">
          <MarkdownEditor isEdit={false} value={description} setValue={setDescription} />
        </Form.Item>
      </Form>
    </Modal>
  )
}
const DataContent = styled.div`
  display: flex;
  justify-content: space-between;
  .content {
    width: 300px;
    height: 176px;
    resize: none;
    margin-top: 12px;
    padding: 10px;
    word-wrap: break-word;
    word-break: break-all;
  }
  textarea {
    resize: none;
    line-height: 1.5;
  }
  .empty-file {
    background: #f7f8f9;
    border-radius: 6px;
    //border: 1px dashed #d9d9d9;
    //div {
    //  //color: #999;
    //  //font-size: 12px;
    //  //margin-top: 8px;
    //  //text-align: center;
    //}
  }
  .readonly-content {
    background: #f7f8f9;
    border-radius: 6px;
    overflow-y: auto;
  }
  .variables {
    border-radius: 6px;
    border: 1px solid #d9d9d9;
    overflow-y: auto;
    display: flex;
  }
  .notes {
    background: #f7f8f9;
    border-radius: 6px;
    font-size: 12px;
    line-height: 18px;
    overflow: scroll;
    padding-right: 0px;
    .note {
      display: flex;
    }
    .name {
      color: #86909c;
      width: 110px;
    }
    .value {
      color: #333333;
      font-size: 12px;
    }
  }
  .file-name {
    max-width: 248px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    margin: 0 10px;
  }
`
const FileName = styled.div`
  height: 32px;
  line-height: 32px;
  display: flex;
  align-items: center;
  .file-name {
    max-width: 886px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    margin: 0 10px;
  }
`
interface EmptyFileProps {
  failed: boolean
}
const EmptyFile = styled.div<EmptyFileProps>`
  border: 1px dashed ${props => (props.failed ? '#F5222D' : '#d9d9d9')};
  .upload-text {
    color: ${props => (props.failed ? '#F5222D' : '#999')};
    font-size: 12px;
    margin-top: 8px;
    text-align: center;
  }
  // span {
  //   color: ${props => (props.failed ? '#F5222D' : '#666666')};
  // }
`
